export const TESTIMONIALS = [
  {
    quote:
      "robloxscripts.gg is the PERFECT website for discovering the latest Roblox scripts for your favorite games. The scripts are high-quality and verified by the community.",
    name: "Furky",
    role: "YouTuber with 265k+ Subscribers",
    imgSrc: "https://cdn.robloxscripts.gg/public/furky/avatar.webp",
  },
  {
    quote:
      "I love how beginner-friendly and easy to use this site is. The scripts are top-notch and the community is always helpful.",
    name: "Sakpot",
    role: "Youtuber with 255k+ Subscribers",
    imgSrc: "/assets/sakpot.webp",
  },
  {
    quote:
      "This site is a goldmine for Roblox scripts; it has everything you need to get started with Roblox exploiting with a Lua executor.",
    name: "WendoJ",
    role: "Script Enthusiast",
    imgSrc: "https://cdn.robloxscripts.gg/public/wendoj/avatar.webp",
  },
  {
    quote:
      "robloxscripts.gg is a great place for a script developer like myself to share my work and get feedback from the community on my Roblox scripts.",
    name: "iMaximus",
    role: "Script Developer",
    imgSrc: "https://cdn.robloxscripts.gg/public/imaximus/avatar.webp",
  },
  {
    quote:
      "I've found so many great scripts here. Just a few clicks and I'm ready to go with my favorite Roblox games like Adopt Me and Blox Fruits.",
    name: "PainExist",
    role: "Youtuber with 146k+ Subscribers",
    imgSrc: "/assets/painexist.webp",
  },
  {
    quote:
      "This is my go-to site for Roblox scripts because the quality and variety of scripts available are unmatched.",
    name: "Arceus",
    role: "Roblox Enthusiast",
    imgSrc: "https://i.pravatar.cc/120?img=2",
  },
  {
    quote:
      "The best place to find and share Roblox scripts. This site has everything you need for Roblox exploiting.",
    name: "Tiahh",
    role: "Script Developer",
    imgSrc: "https://i.pravatar.cc/120?img=3",
  },
];
